function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Filter from './filter';
import Collection from './collection';
import User from './user';

var Subusers = /*#__PURE__*/function (_Collection) {
  _inheritsLoose(Subusers, _Collection);

  function Subusers() {
    return _Collection.apply(this, arguments) || this;
  }

  var _proto = Subusers.prototype;

  _proto.initialize = function initialize() {
    this.filter = new Filter();
  };

  _proto.url = function url() {
    return '/api/account/users';
  };

  _proto.search = function search(term) {
    return this.fetch({
      data: {
        search: term
      }
    });
  };

  _proto.params = function params(obj) {
    if (obj != null) {
      return this.filter.set(obj);
    } else {
      return this.filter.attributes;
    }
  };

  _createClass(Subusers, [{
    key: "model",
    get: function get() {
      return User;
    }
  }]);

  return Subusers;
}(Collection);

export { Subusers as default };